export const inputStyles = {
  variants: {
    profile: {
      field: {
        bg: "white",
        border: "1.5px solid",
        borderColor: "rgba(67,0,152,0.16)",
        borderRadius: "12px",
        h: "46px",
        color: "primary",
        fontWeight: "600",
        _placeholder: { color: "gray.400", fontWeight: "400" },
        _hover: { borderColor: "rgba(67,0,152,0.32)" },
        _focusVisible: { borderColor: "primary", boxShadow: "0 0 0 1px var(--chakra-colors-primary)" },
        _disabled: { bg: "rgba(67,0,152,0.035)", color: "gray.500", cursor: "not-allowed", opacity: 1 }
      }
    }
  }
};
